import { useLocale } from '@/i18n/locale-context';
import { scrollToTop } from '@/lib/dom';
import { useScrollProgress } from '@/lib/hooks';
import { cn } from '@/components/ui';
import { Icon } from './Icon';

/** `.totop` from the supplied design: appears after a screenful of scrolling. */
export function BackToTop() {
  const { t } = useLocale();
  const { scrolled } = useScrollProgress();
  const visible = scrolled > 600;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label={t('action.backToTop')}
      data-print-hide
      // Hidden from the tab order while invisible — a focus ring on a button nobody can
      // see is the classic "keyboard focus disappeared" bug.
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
      className={cn(
        'fixed bottom-6 right-6 z-40 grid h-10 w-10 place-items-center rounded-md border border-line bg-white shadow-float transition',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <Icon name="arrow-up" size={16} className="text-ink" />
    </button>
  );
}
